import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import PostCard from '../components/PostCard'
import CreatePost from '../components/CreatePost'
import { Loader2, TrendingUp, Users, MessageSquare } from 'lucide-react'

const Home = () => {
  const { api, user } = useAuth()
  const [posts, setPosts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [stats, setStats] = useState({
    totalPosts: 0,
    totalComments: 0,
    activeUsers: 0
  })

  useEffect(() => {
    fetchPosts()
    fetchStats()
  }, [])

  const fetchPosts = async () => {
    try {
      const response = await api.get('/posts')
      if (response.data.success) {
        setPosts(response.data.data.posts)
      }
    } catch (error) {
      console.error('Failed to fetch posts:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchStats = async () => {
    try {
      const response = await api.get('/users/stats')
      if (response.data.success) {
        setStats(response.data.data)
      }
    } catch (error) {
      console.error('Failed to fetch stats:', error)
    }
  }

  const handleNewPost = (newPost) => {
    setPosts(prev => [newPost, ...prev])
    setStats(prev => ({ ...prev, totalPosts: prev.totalPosts + 1 }))
  }

  const handleDelete = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId))
    setStats(prev => ({ ...prev, totalPosts: prev.totalPosts - 1 }))
  }

  return (
    <div className="max-w-3xl mx-auto">
      {/* Stats bar */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
            <MessageSquare className="w-5 h-5 text-primary-600" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{stats.totalPosts}</p>
            <p className="text-xs text-gray-500">Confessions</p>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 flex items-center space-x-3">
          <div className="w-10 h-10 bg-anonymous-100 rounded-full flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-anonymous-600" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900\">{stats.totalComments}</p>
            <p className="text-xs text-gray-500">Comments</p>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 flex items-center space-x-3">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
            <Users className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900\">{stats.activeUsers}</p>
            <p className="text-xs text-gray-500">Active Users</p>
          </div>
        </div>
      </div>

      {/* Create post */}
      {user && <CreatePost onPostCreated={handleNewPost} />}

      {/* Posts feed */}
      <div className="space-y-4">
        {isLoading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-primary-600" />
          </div>
        ) : posts.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
            <MessageSquare className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No confessions yet</h3>
            <p className="text-gray-500 mb-4">Be the first to share your thoughts anonymously</p>
            {!user && (
              <a href="/register" className="btn-primary">
                Get Started
              </a>
            )}
          </div>
        ) : (
          posts.map((post) => (
            <PostCard 
              key={post._id} 
              post={post}
              onDelete={handleDelete}
            />
          ))
        )}
      </div>
    </div>
  )
}

export default Home